import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useQueryParams from 'react-scale/corp/hooks/useQueryParams';

export const useSetQueryParams = () => {
  const location = useLocation();
  const history = useHistory();

  const params = useQueryParams();

  const setQueryParams = useCallback(
    (newParams: Record<string, string>) => {
      const paramCopy: Record<string, string> = Object.assign({}, params as Record<string, string>);
      Object.entries(newParams).forEach(([key, value]) => (paramCopy[key] = value));
      const updatedParams = new URLSearchParams(
        Object.entries(paramCopy).map(([key, value]) => [key, value ?? '']),
      );
      history.push({
        pathname: location.pathname,
        search: updatedParams.toString(),
      });
    },
    [history, location.pathname, params],
  );

  return {
    setQueryParams,
  };
};
